import React from 'react';

interface ISmartphoneMockupProps {
  width?: number;
  height?: number;
  imageUrl?: string;
  alt?: string;
}

export const SmartphoneMockup: React.FC<ISmartphoneMockupProps> = ({
  width = 280,
  height = 360,
  imageUrl,
  alt = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 280 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={alt}
    >
      <defs>
        <clipPath id="phoneScreenClip">
          <rect x="24" y="30" width="232" height="310" rx="4" />
        </clipPath>
      </defs>
      <rect
        x="10"
        y="5"
        width="260"
        height="350"
        rx="30"
        fill="white"
        stroke="#E3E4E8"
        strokeWidth="2"
      />
      {imageUrl ? (
        <image
          href={imageUrl}
          x="24"
          y="30"
          width="232"
          height="310"
          clipPath="url(#phoneScreenClip)"
          preserveAspectRatio="xMidYMid slice"
        />
      ) : (
        <rect x="24" y="30" width="232" height="310" rx="4" fill="#F1FCEF" />
      )}
    </svg>
  );
};
